// Named so a caller can tell "the token never arrived" from "my own logic broke". The Hasura store
// already reports the token failure at source, so best-effort callers swallow this rather than
// reporting it a second time. Its own module so nothing has to import the router to catch it.
export class HasuraNotAuthenticatedError extends Error {
  constructor() {
    super("Hasura status = error");
    this.name = "HasuraNotAuthenticatedError";
  }
}
